import * as React from "react";

import { useAppSelector } from "../../store/hooks";
import { SpecialBettingsColorEnum } from "../../enums";

import StakeNumber from "./StakeNumber";

const ColorBoard: React.FC = () => {
  const colorStakeMultipliers = useAppSelector(
    (state) => state.config.colorStakeMultipliers
  );
  const numberStakeMultipliers = useAppSelector(
    (state) => state.config.numberStakeMultipliers
  );

  return (
    <div className="single_number_row">
      <StakeNumber
        value={SpecialBettingsColorEnum.RED}
        stakes={colorStakeMultipliers}
      />
      <StakeNumber value="0" stakes={numberStakeMultipliers} />
      <StakeNumber
        value={SpecialBettingsColorEnum.BLACK}
        stakes={colorStakeMultipliers}
      />
    </div>
  );
};

export default ColorBoard;
